import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
// import './loginPage.css';
import bcrypt from 'bcryptjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import LoginMessage from './loginMessage/LoginMessage';

const saltRounds = 10;

function LoginPage() {
    const [data, setData] = useState('');

    // Sets the Login Message component
    const setLoginMessage = (msg) => {
        setData(msg);
    }

    const ref = useRef(null);

    useEffect(() => {
        const handleSubmit = async (event) => {
            event.preventDefault();
            // console.log('Form Submitted');
            // console.log(element.action);
            // console.log(event);

            let password = event.target.password.value;

            const hashedPassword = await new Promise((resolve, reject) => {
                bcrypt.hash(password, saltRounds, function(err, hash) {
                  if (err) reject(err)
                  resolve(hash)
                });
              })
            // console.log(hashedPassword);
            // event.target.password.value = hashedPassword;
            console.log(import.meta.env.VITE_DEVBACKENDPATH);
            try {
                const isLogin = await axios({
                        url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/auth/login`, 
                        method: 'POST',
                        withCredentials: true,
                        credentials: 'include',
                        headers: {
                            // ADDED Security Measure
                            //apiKey: 'qazwsxedcrfvvfrcdexswzaq',
                            // 'Access-Control-Allow-Origin': 'http://localhost:8080/api/auth/login'
                        },
                        data: {
                            email: event.target.email.value,
                            password: event.target.password.value
                        }
                });    
                console.log(isLogin);
                const expireDate = new Date();
                expireDate.setTime(expireDate.getTime() + (1*24*60*60*1000));
                localStorage.setItem('refresh', 'true');
                // document.cookie = `data=${JSON.stringify(isLogin.data.data.loginToken)}; expires=${expireDate}; + path=/;`;
                // document.cookie = `username=${JSON.stringify(isLogin.data.data.username)}; expires=${expireDate}; + path=/;`;
                // document.cookie = `email=${JSON.stringify(isLogin.data.data.email)}; expires=${expireDate}; + path=/;`;

                setLoginMessage('Successfully Logged in');

                // Wait 2 seconds then redirect the user to dashboard page 
                setTimeout(() => {
                    location.href = "/dashboard";
                }, 2000);
                
            } catch(err){
                console.log(err);
                if(err.response.status === 429) setLoginMessage("Too many failed login attempts. Please try again in 15 minutes.");
                else setLoginMessage('invalid credentials, please try a different combination');
                // return document.getElementById('root').append(document.createElement('div').innerHTML=err.message);
            }
            // console.log(isLogin.status);
            // return document.getElementById('root').append(document.createElement('div').innerHTML=isLogin.data.message);
        };
    
        const element = ref.current;
    
        element.addEventListener('submit', handleSubmit);
    
        return () => {
            element.removeEventListener('submit', handleSubmit);
        };
    },[]);

    return (
        <article className='margin-t-xxl margin-b-lg'>
            <section className='border rounded padding-lg margin-t-lg margin-b-lg'>
                <div className='flex row margin-b-lg'>
                    <FontAwesomeIcon className='h1' icon={faRightToBracket} size='2xl' /> 
                    <h2 className='h1'>Login</h2>
                </div>
                <LoginMessage setLoginMessage={data}/>
                <form id="loginForm" className='' ref={ref} action="" rel="external" method="get">
                    <div id='emailfield' className='flex column margin-b-md'>
                        <label htmlFor="email" className='h3'><b>Email:</b></label>
                        <input id="email" className='input padding-r-3xl' name='email' type="text" autoComplete='email' placeholder='email address...' required autoFocus/>
                    </div>
                    <div id='passfield' className='flex column margin-b-md'>
                        <label htmlFor="password" className='h3'><b>Password:</b></label>
                        <input id="password" className='input' name="password" type="password" autoComplete='password' placeholder='password...' required/>
                    </div>
                    <div id='formbtns' className=''>
                        <button id='login' type="submit" className='button margin-r-sm'><b>Login</b></button>
                        <a href='/register'className='button'><b>Sign up</b></a>
                    </div>
                </form>
            </section>
        </article>
    );
}

export default LoginPage;
